// VisitorAPI geolocates the visitor by IP; the signup form uses it to
// pre-select the US state. This is VisitorAPI's public browser key, shipped in
// the bundle by design and restricted to our domains on their side.
// deepcode ignore HardcodedNonCryptoSecret: public, domain-restricted browser key for a geolocation lookup, not a credential
export const VISITOR_API_KEY = "ergzJlGzYyWUs6HKUbmN";
